
import React, { useEffect, useState } from "react";
import TopSection from "../../Components/Common/Top/TopSection";
import {
    Stack,
    Grid,
    Tooltip,
    Skeleton,
    IconButton,
} from "@mui/material";
import DataTable from "../../Components/Common/datatable/DataTable";
import { Timestamp } from "../../Components/Common/DateFormatter";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import TicketDetailsDialog from "./ticketDetailsDialog";
import ApiService from "../../utils/fetch";
import RefreshIcon from "@mui/icons-material/Refresh";


const TicketSummary = () => {
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [ticketDetails, setTicketDetails] = useState(null)
    const [filteredData, setFilteredData] = useState([]);
    const pagination = true;
    const paginationPageSize = 10;
    const paginationPageSizeSelector = [5, 10, 20, 50, 100];

    const columnDefinition = [
        {
            field: "menu",
            headerName: "Menu",
            sortable: true,
            unSortIcon: true,
            filterParams: {
                filterOptions: ["contains", "startsWith", "endsWith"],
                defaultOption: "contains",
                buttons: ["apply", "reset"],
            },
            filter: "agTextColumnFilter",
            width: 160,
            cellRenderer: (params) => (
                <Tooltip title={`${params.data.menu}`} arrow>
                    <div>{params.data.menu}</div>
                </Tooltip>
            ),
        },
        {
            field: "submenu",
            headerName: "Submenu",
            sortable: true,
            unSortIcon: true,
            filterParams: {
                filterOptions: ["contains", "startsWith", "endsWith"],
                defaultOption: "contains",
                buttons: ["apply", "reset"],
            },
            filter: "agTextColumnFilter",
            width: 160,
            cellRenderer: (params) => (
                <Tooltip title={`${params.data.submenu}`} arrow>
                    <div>{params.data.submenu}</div>
                </Tooltip>
            ),
        },
        // {
        //     field: "title",
        //     headerName: "Title",
        //     sortable: true,
        //     unSortIcon: true,
        //     filterParams: {
        //         filterOptions: ["contains", "startsWith", "endsWith"],
        //         defaultOption: "contains",
        //         buttons: ["apply", "reset"],
        //     },
        //     filter: "agTextColumnFilter",
        //     width: 180,
        //     cellRenderer: (params) => (
        //         <Tooltip title={`${params.data.title}`} arrow>
        //             <div>{params.data.title}</div>
        //         </Tooltip>
        //     ),
        // },
                {
            field: "category",
            headerName: "Category",
            sortable: true,
            unSortIcon: true,
            filterParams: {
                filterOptions: ["contains", "startsWith", "endsWith"],
                defaultOption: "contains",
                buttons: ["apply", "reset"],
            },
            filter: "agTextColumnFilter",
            width: 160,
            cellRenderer: (params) => (
                <Tooltip title={`${params.data.category}`} arrow>
                    <div>{params.data.category}</div>
                </Tooltip>
            ),
        },
        {
            field: "functionality",
            headerName: "Functionality",
            sortable: true,
            unSortIcon: true,
            filterParams: {
                filterOptions: ["contains", "startsWith", "endsWith"],
                defaultOption: "contains",
                buttons: ["apply", "reset"],
            },
            filter: "agTextColumnFilter",
            width: 160,
            cellRenderer: (params) => (
                <Tooltip title={`${params.data.functionality}`} arrow>
                    <div>{params.data.functionality}</div>
                </Tooltip>
            ),
        },
        {
            field: "alIdentifier",
            headerName: "AL Identifier",
            sortable: true,
            unSortIcon: true,
            filterParams: {
                filterOptions: ["contains", "startsWith", "endsWith"],
                defaultOption: "contains",
                buttons: ["apply", "reset"],
            },
            filter: "agTextColumnFilter",
            width: 200,
            cellRenderer: (params) => (
                <Tooltip title={`${params.data.alIdentifier}`} arrow>
                    <div>{params.data.alIdentifier}</div>
                </Tooltip>
            ),
        },
        {
            field: "creationStatus",
            headerName: "Is Ticket Created",
            sortable: true,
            unSortIcon: true,
            filterParams: {
                filterOptions: ["contains"],
                buttons: ["apply", "reset"],
            },
            filter: "agTextColumnFilter",
            width: 210,
            cellRenderer: (params) => {
                const isSuccess = params.data.creationStatus === true;
                const displayText = isSuccess ? "Yes" : "No";
                return (
                    <Tooltip title={displayText} arrow>
                        <div>{displayText}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: "ticketNo",
            headerName: "Ticket Number",
            sortable: true,
            unSortIcon: true,
            filterParams: {
                filterOptions: ["contains", "startsWith", "endsWith"],
                defaultOption: "contains",
                buttons: ["apply", "reset"],
            },
            filter: "agTextColumnFilter",
            width: 200,
            cellRenderer: (params) => (
                <Tooltip title={`${params.data.ticketNo}`} arrow>
                    <div>{params.data.ticketNo}</div>
                </Tooltip>
            ),
        },
        {
            field: "createdBy",
            headerName: "Initiated By",
            sortable: true,
            unSortIcon: true,
            filterParams: {
                filterOptions: ["contains", "startsWith", "endsWith"],
                defaultOption: "contains",
                buttons: ["apply", "reset"],
            },
            filter: "agTextColumnFilter",
            width: 190,
            cellRenderer: (params) => (
                <Tooltip title={`${params.data.createdBy}`} arrow>
                    <div>{params.data.createdBy}</div>
                </Tooltip>
            ),
        },
        {
            field: "createAt",
            headerName: "Initiated Date-Time(UTC)",
            sortable: true,
            sort: "desc",
            filterParams: {
                comparator: function (filterDate, cellValue) {
                    if (!cellValue) return -1;

                    const cellDate = new Date(cellValue);
                    // Strip time and compare only YYYY-MM-DD
                    const cellDateOnly = new Date(
                        cellDate.getFullYear(),
                        cellDate.getMonth(),
                        cellDate.getDate()
                    );

                    return cellDateOnly.getTime() - filterDate.getTime();
                },
                filterOptions: ["equals", "inRange"],
                defaultOption: "equals",
                buttons: ["apply", "reset"],
            },
            filter: "agDateColumnFilter",
            width: 260,
            valueFormatter: (params) => {
                return Timestamp(params.value);
            },
        },
        {
            headerName: "View Details",
            sortable: false,
            width: 140,
            resizable: false,
            cellRenderer: (params) => (
                <div
                    onClick={() => handleOpen(params.data)}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                    }}
                >
                    <VisibilitySharpIcon />
                </div>
            ),
        }
    ];

    const handleOpen = async (rowData) => {
        const id = rowData.id;

        const fetchData = async () => {
            try {
                const response = await ApiService.get(
                    `/v1/dynamic-ticket/get-ticket-detail?id=${id}`
                );
                console.log("Fetched ticket details:", response.data);
                setTicketDetails(response.data);
            } catch (error) {
                console.error("Failed to fetch ticket details:", error);
            }
        };

        fetchData();
        setOpen(true);
    };


    const handleClose = () => {
        setOpen(false);
        setTicketDetails(null);
    };

    useEffect(() => {
        refreshTickets();
    }, []);

    const refreshTickets = async () => {
        setLoading(true);
        try {
            const response = await ApiService.get(`/v1/dynamic-ticket/get-all-details`);
            console.log("Refreshed ticket data:", response.data);
            setFilteredData(response.data);
        } catch (error) {
            console.error("Failed to refresh tickets:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <Stack>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ mb: -1 }}
                        >
                            {/* Heading */}
                            <TopSection
                                labelList={[
                                    { title: "Home", path: "/dashboard" },
                                    { title: "Ticket Summary" },
                                ]}
                                title="Ticket Summary"
                            />

                            {/* Refresh Button */}
                            <Tooltip title="Refresh">
                                <span>
                                    <IconButton
                                        onClick={refreshTickets}
                                        disabled={loading}
                                        sx={{
                                            ml: 2,
                                            backgroundColor: loading ? "grey.300" : "transparent",
                                            "&:hover": { backgroundColor: "grey.100" },
                                        }}
                                    >
                                        <RefreshIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Stack>
                    </Grid>

                    <Grid item xs={12}>
                        <div class="container">

                            <Grid xs={12}>
                                {loading ? (
                                    <Skeleton
                                        variant="rectangular"
                                        height="80vh"
                                        animation="pulse"
                                        style={{ marginBottom: "16px", borderRadius: "8px" }}
                                    />
                                ) : (
                                    <DataTable
                                        columns={columnDefinition}
                                        rows={filteredData || []}
                                        pagination={pagination}
                                        paginationPageSize={paginationPageSize}
                                        paginationPageSizeSelector={paginationPageSizeSelector}
                                        tableHeight={'80vh'}
                                        suppressMovableColumns={true}
                                        suppressHorizontalScroll={false}
                                        suppressPaginationPanel={false}
                                        onSelectionChanged={true}
                                    />
                                )}
                            </Grid>
                        </div>

                    </Grid>
                </Grid>
            </Stack>

            <TicketDetailsDialog
                open={open}
                onClose={handleClose}
                ticketDetails={ticketDetails}
            />
        </>
    );
};

export default TicketSummary;

